"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ExtendableError_1 = __importDefault(require("./ExtendableError"));
/**
 * Thrown when a function is called with a missing mandatory parameter
 * @param {string} paramName
 */
class MissingParamError extends ExtendableError_1.default {
    constructor(paramName) {
        super(`missing ${paramName}`);
        this.paramName = paramName;
    }
}
exports.default = MissingParamError;
